// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kHe-t","title":"styles_title__2dlsf"};